import {
  Container,
  Group,
  NavLink,
  Paper,
  Stack,
} from '@mantine/core';
import BusinessIcon from '@mui/icons-material/Business';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Groups3Icon from '@mui/icons-material/Groups3';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import {
  createFileRoute,
  Link,
  Outlet,
  useNavigate,
} from '@tanstack/react-router';
import {
  useEffect,
  useState,
} from 'react';
import {
  useAuth,
} from 'react-oidc-context';

import styles from '#features/scout/Settings.module.scss';
import {
  type AuthDecoded,
} from '#src/types/auth';
export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout/settings',
)({
  beforeLoad: () => {
    return {
      crumb: 'Settings',
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const auth = useAuth();
  const [
    user,
    setUser,
  ] = useState<AuthDecoded>();
  useEffect(() => {
    if (auth.user) {
      setUser(auth.user as unknown as AuthDecoded);
    }
  }, [auth.user]);
  return (
    <>
      <Group
        w="100%"
        wrap="nowrap"
        preventGrowOverflow={ false }
        grow
      >
        <Stack
          className={ styles.sectionsCol }
          justify="flex-start"
          align="stretch"
          gap="xs"
          h="100%"
        >
          { user?.profile?.groups.includes('client-admin') && (
            <NavLink
              className={ styles.navLinks }
              component={ Link }
              to="/mydigitalworkers/scout/settings/users"
              variant="filled"
              label="Users"
              description="Manage digital worker user roles, permissions and accessibility "
              leftSection={ <Groups3Icon /> }
              rightSection={ <ChevronRightIcon /> }
            />
          ) }
          <NavLink
            className={ styles.navLinks }
            component={ Link }
            to="/mydigitalworkers/scout/settings/ssid"
            variant="filled"
            label="ATO Connection"
            description="Configure your digital worker subscription's connection to the Australian Tax Office (ATO)."
            leftSection={ <BusinessIcon /> }
            rightSection={ <ChevronRightIcon /> }
          />
        </Stack>
        <Container
          className={ styles.outletCol }
          mx={ 0 }
          miw="80%"
        >
          <Outlet />
        </Container>
      </Group>
    </>
  );
}
